import './ChatBubble.css'

import { cx } from '../utilities/cx'

export type ChatBubbleProps = {
  className?: string
  sender?: 'user' | 'assistant' | 'status'
  children: React.ReactNode
  /** Stable key for Rheya TTS play/stop */
  audioKey?: string
  audioPlaying?: boolean
  onAudioPress?: () => void
}

export const ChatBubble = (props: ChatBubbleProps) => {
  const {
    className,
    sender = 'assistant',
    children,
    audioKey,
    audioPlaying = false,
    onAudioPress,
  } = props

  const showAudio = sender === 'assistant' && !!audioKey && !!onAudioPress
  const classNames = cx(
    'chat-bubble',
    `chat-bubble--${sender}`,
    showAudio && 'chat-bubble--has-audio',
    className,
  )

  return (
    <div className={classNames}>
      <div className="chat-bubble__body">{children}</div>
      {showAudio ? (
        <button
          type="button"
          className={cx('chat-bubble__audio', audioPlaying && 'chat-bubble__audio--playing')}
          aria-label={audioPlaying ? 'Stop audio' : 'Play audio'}
          onClick={onAudioPress}
        >
          {audioPlaying ? (
            <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden>
              <rect x="6" y="6" width="12" height="12" fill="currentColor" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden>
              <path d="M8 5v14l11-7z" fill="currentColor" />
            </svg>
          )}
        </button>
      ) : null}
    </div>
  )
}
